var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrending = function SvgTrending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 0L9.5025 1.33583L6.65583 4.1825L4.3225 1.84917L0 6.1775L0.8225 7L4.3225 3.5L6.65583 5.83333L10.3308 2.16417L11.6667 3.5V0H8.16667Z",
    fill: "currentColor"
  })));
};
export default SvgTrending;